import { arrayOf, Schema } from 'normalizr';


const SITE_FOOTER_LINK_TRANSLATION_SCHEMA = new Schema('siteFooterLinkTranslations');
const SITE_FOOTER_LINK_SCHEMA = new Schema('siteFooterLinks');
SITE_FOOTER_LINK_SCHEMA.define({
  translations: arrayOf(SITE_FOOTER_LINK_TRANSLATION_SCHEMA),
});
export const SITE_FOOTER_LINKS_SCHEMA = arrayOf(SITE_FOOTER_LINK_SCHEMA);

const CATEGORY_SCHEMA = new Schema('categories');
export const CATEGORIES_SCHEMA = arrayOf(CATEGORY_SCHEMA);
